import { SelectUsersComponent } from './select-users.component';

export default angular
  .module('sfMobile.components.select-users', [
    'sfMobile.services.users',
    'sfMobile.components.content',
    'sfMobile.components.input-checkbox-item',
  ])
  .component('sfSelectUsers', SelectUsersComponent).name;
